<!--
 * @Author: Shao Wei
 * @Date: 2022-10-20 15:35:22
 * @LastEditors: Shao Wei
 * @LastEditTime: 2022-10-24 13:20:06
 * @Description: file content
 * @FilePath: /leopard-web-vehicle/src/views/finance/components/ReceiptRefund.vue
-->
<template>
<div>
  <dialogWrap
    v-model="isShow"

    title="创建退款单"
    @change="changeHandle"
    :width="'524px'"
  >
            <el-form
                ref="receiptRefund"
                :model="receiptRefundData"
                :rules="rules"
            >
                <el-form-item
                    prop="refundableAmount"
                    label="最大可退金额："
                >{{refundableAmount}}元</el-form-item>
                <el-form-item
                    prop="refundAmount"
                    label="本次退款金额："
                >
                    <el-col :span="12">
                        <el-input
                            v-limit-money="true"
                            v-model="receiptRefundData.refundAmount"
                            placeholder="请输入"
                            class="width171"
                            clearable
                            maxlength="13"
                            >
                            <template slot="append">元</template>
                        </el-input>
                    </el-col>
                </el-form-item>
            </el-form>
            <template slot="footer">
      <el-button size="small" @click="cancel">取消</el-button>
      <el-button
        :loading="loading"
        size="small"
        type="primary"
        @click="initiateRefund"
        >发起退款</el-button
      >
    </template>
  </dialogWrap>
  <!-- 二次确认弹窗 -->
  <dialogWrap
    v-model="confirmShow"

    title="请确认退款内容"
    :width="'524px'"
  >
    <el-form>
        <el-form-item label="本次退款金额：">
            {{parseFloat(receiptRefundData.refundAmount).toFixed(2)}}元
        </el-form-item>
        <el-form-item label="相关车辆：">
            {{receiptItem.plateNo}}
        </el-form-item>
        <el-form-item label="收款方：">
            {{receiptItem.customerName}}
        </el-form-item>
        <el-form-item label="退款方式：">
            原路退回
        </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button size="small" @click="cancelConfirm">取消</el-button>
      <el-button
        :loading="loading"
        size="small"
        type="primary"
        @click="onOk"
        >确认</el-button
      >
    </template>
  </dialogWrap>
</div>
</template>

<script>
import { addRefund } from '@/api/financeApi'
import { debounce } from '@/utils'

export default {
  components: {},
  model: {
    prop: 'show',
    event: 'change',
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    receiptItem: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    show(val) {
      this.isShow = val
    },
    isShow(val) {
      this.$emit('change', val)
    },
  },
  data() {
    return {
      isShow: false,
      loading: false,
      confirmShow: false,
      receiptRefundData: { refundAmount: 0 },
    }
  },
  methods: {
    changeHandle(bol) {
      if (!bol) {
        this.$refs.receiptRefund.resetFields()
      }
    },
    initiateRefund() {
      // 表单验证
      this.$refs.receiptRefund.validate((valid) => {
        if (valid) {
          this.confirmShow = true
        }
      })
    },
    cancel() {
      this.$refs.receiptRefund.resetFields()
      this.isShow = false
    },
    cancelConfirm() { this.confirmShow = false },
    // 确认修改
    onOk: debounce(async function () {
      const { id: receiptId } = this.receiptItem
      const { refundAmount: amount } = this.receiptRefundData
      const { code } = await addRefund({
        receiptId,
        amount,
        mode: 0,
      })
      if (code === 1) {
        this.confirmShow = false
        this.isShow = false
        this.$message.success('创建成功')
        this.$emit('postRefund', this.receiptRefundData)
      }
    }),
    validatePass(rule, value, callback) {
      if (!value) { callback(new Error('退款金额不能为空！')) }
      if (Number(value) > Number(this.refundableAmount)) {
        callback(new Error('不能超过最大可退金额！'))
      }
      callback()
    },
  },
  computed: {
    rules() {
      return {
        refundAmount: [
          { validator: this.validatePass, trigger: 'blur' },
        ],
      }
    },
    refundableAmount(newVal) {
      if (newVal) {
        // 最大可退金额：收款金额-退款中金额-已退金额
        const { amount, processRefundAmount, completeRefundAmount } = this.receiptItem
        return (Number(amount) - Number(processRefundAmount) - Number(completeRefundAmount)).toFixed(2)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.box-wrap {
  ::v-deep .el-input--small {
    width: 205px;
  }
}
</style>
